var _g, _g2, _path, _path2, _path3, _path4, _path5, _g3, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g4, _g5, _g6, _g7, _g8, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-ec",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe800",
    d: "M0 0h511.993v511.984H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00148e",
    d: "M0 255.992h511.993v255.992H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da0010",
    d: "M0 383.993h511.993v128H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.47 244.16l-54.66 57.728-.964-1.24 54.662-57.728.963 1.24zm38.082 9.434L180.018 329l-1.254-1.186 71.533-75.407 1.255 1.187z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 60.236v88.583l17.717 88.582 17.717-88.583V60.235H478.35z",
    transform: "matrix(-.052 -.05 -.067 .068 210.06 348.857)",
    stroke: "#000",
    strokeWidth: 4.104,
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 60.236v88.583l17.717 88.582 17.717-88.583V60.235H478.35z",
    transform: "matrix(-.052 -.05 -.067 .068 191.615 319.402)",
    stroke: "#000",
    strokeWidth: 4.104,
    fill: "gray"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.18 272.84s-17.716 336.61 53.15 336.61 106.3-35.433 106.3-35.433l-.86-185.03-158.59-116.15z",
    fillRule: "evenodd",
    transform: "matrix(.34 0 0 .486 64.646 -20.46)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ffdf00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M344.46 304.2c0 17.717-7.846 269.82 27.587 269.82s88.583-17.717 88.583-17.717l-.86-167.31-115.31-84.79z",
    fillRule: "evenodd",
    transform: "matrix(.34 0 0 .486 64.646 -20.46)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#0000c4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M367.52 321.16c0 17.717 4.525 217.42 39.958 217.42h53.15l-.86-149.59-92.248-67.833z",
    fillRule: "evenodd",
    transform: "matrix(.34 0 0 .486 64.646 -20.46)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#e10000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.66 112.217l54.66 57.728.965-1.24-54.662-57.728-.964 1.24z",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M301.18 272.84s-35.433 336.61 70.866 336.61c88.583 0 88.583-53.15 106.3-53.15l-17.72-124.02-159.45-159.44z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ffdf00",
    transform: "matrix(.44 0 0 .465 17.296 16.967)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.59 155.24c1.133 0 28.318-94.016 118.94-147.25",
    transform: "matrix(.29 -.02 -.038 .265 112.022 135.874)",
    strokeWidth: 2.305,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z",
    fillRule: "evenodd",
    transform: "matrix(.105 -.166 .22 .105 142.767 218.893)",
    strokeWidth: "1pt",
    fill: "#005b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z",
    fillRule: "evenodd",
    transform: "matrix(.137 -.076 .067 .132 144.082 218.38)",
    strokeWidth: "1pt",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z",
    fillRule: "evenodd",
    transform: "matrix(.133 .09 -.096 .25 146.638 97.413)",
    strokeWidth: "1pt",
    fill: "#005b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z",
    fillRule: "evenodd",
    transform: "matrix(.132 -.023 -.023 .245 145.367 144.856)",
    strokeWidth: "1pt",
    fill: "#005b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z",
    fillRule: "evenodd",
    transform: "matrix(.048 .19 -.13 .146 182.098 58.956)",
    strokeWidth: "1pt",
    fill: "#005b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z",
    fillRule: "evenodd",
    transform: "matrix(.156 -.14 .14 .178 123.442 206.61)",
    strokeWidth: "1pt",
    fill: "#005b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z",
    fillRule: "evenodd",
    transform: "matrix(.164 -.17 .19 .153 112.346 237.575)",
    strokeWidth: "1pt",
    fill: "#005b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z",
    fillRule: "evenodd",
    transform: "matrix(.194 .072 -.145 .24 108.735 136.094)",
    strokeWidth: "1pt",
    fill: "#005b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z",
    fillRule: "evenodd",
    transform: "matrix(.114 .158 -.242 .167 144.75 102.653)",
    strokeWidth: "1pt",
    fill: "#005b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z",
    fillRule: "evenodd",
    transform: "matrix(.06 .066 -.102 .123 199.228 102.117)",
    strokeWidth: "1pt",
    fill: "#005b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z",
    fillRule: "evenodd",
    transform: "matrix(.08 .004 -.06 .13 189.73 127.605)",
    strokeWidth: "1pt",
    fill: "#005b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z",
    fillRule: "evenodd",
    transform: "matrix(-.007 .11 -.103 .062 226.927 85.88)",
    strokeWidth: "1pt",
    fill: "#005b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z",
    fillRule: "evenodd",
    transform: "matrix(.05 .087 -.19 .115 176.592 111.9)",
    strokeWidth: "1pt",
    fill: "#005b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z",
    fillRule: "evenodd",
    transform: "matrix(.098 .168 -.252 .15 166.287 77.567)",
    strokeWidth: "1pt",
    fill: "#005b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.59 155.24c1.133 0 28.318-94.016 118.94-147.25",
    transform: "matrix(.266 -.148 .107 .21 94.38 196.598)",
    strokeWidth: 2.37,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z",
    fillRule: "evenodd",
    transform: "matrix(.137 -.076 .067 .132 161.236 194.184)",
    strokeWidth: "1pt",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z",
    fillRule: "evenodd",
    transform: "matrix(.137 -.076 .067 .132 169.374 189.382)",
    strokeWidth: "1pt",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z",
    fillRule: "evenodd",
    transform: "matrix(.14 -.08 .05 .1 135.93 200.28)",
    strokeWidth: "1pt",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z",
    fillRule: "evenodd",
    transform: "matrix(.14 -.08 .05 .1 138.282 199.258)",
    strokeWidth: "1pt",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z",
    fillRule: "evenodd",
    transform: "matrix(.14 -.08 .05 .1 136.93 201.448)",
    strokeWidth: "1pt",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z",
    fillRule: "evenodd",
    transform: "matrix(.152 -.084 .074 .147 144.922 210.722)",
    strokeWidth: "1pt",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z",
    fillRule: "evenodd",
    transform: "matrix(.152 -.084 .074 .147 146.656 208.927)",
    strokeWidth: "1pt",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z",
    fillRule: "evenodd",
    transform: "matrix(.152 -.084 .074 .147 147.092 209.79)",
    strokeWidth: "1pt",
    fill: "red"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M336.61 308.27c0 17.717-35.433 212.6 53.15 265.75 35.433 17.716 88.582-17.717 88.582 0l-17.71-141.74-124.02-124.01z",
    fillRule: "evenodd",
    transform: "matrix(.44 0 0 .465 17.296 16.967)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#0000c4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M372.05 343.7c0 17.717-17.716 159.45 35.433 194.88 35.433 35.433 124.02 25.822 124.02 25.822l-70.87-132.12-88.58-88.58z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#e10000",
    transform: "matrix(.44 0 0 .465 17.296 16.967)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.788 143.962l71.534 75.408 1.255-1.187-71.534-75.407-1.255 1.186z",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M460.63 184.25l17.716 35.433V237.4c-.865-1.305 0 17.716-17.716 17.716-17.717 0-17.717-35.433-17.717-35.433s-17.716 35.433-17.716 70.866 17.716 53.15 17.716 53.15-2.61-36.704 17.717-35.434c20.328 1.27 17.716 17.716 17.716 17.716v35.433h17.717v-141.73l17.717-35.433-27.136-53.15-26.014 53.15z",
    fillRule: "evenodd",
    transform: "matrix(.102 -.107 .08 .082 75.203 169.68)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#cececc"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M557.82 95.67l-26.323 70.865 17.717 53.15-35.433-17.716 35.434 53.148v35.433h17.716v-35.43l35.433-53.15-35.433 17.717 17.717-53.15L557.82 95.67z",
    fillRule: "evenodd",
    transform: "matrix(.08 -.12 .105 .07 96.06 163.395)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#cececc"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c0 35.8 20.917 187.81 22.582 191.56.14 4.44-4.718 6.382-7.077.832-6.55-17.342-20.743-159.91-21.332-193.22-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z",
    fillRule: "evenodd",
    transform: "matrix(.303 0 0 .234 43.048 77.33)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#e10000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c31.488 61.414 48.722 166.77 50.387 170.52.14 4.44-4.718 6.382-7.077.832-2.48-3.315-12.667-100.18-49.138-172.18-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z",
    fillRule: "evenodd",
    transform: "matrix(.285 .07 -.114 .22 67.428 53.448)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#0000c4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c0 35.8 20.917 187.81 22.582 191.56.14 4.44-4.718 6.382-7.077.832-6.55-17.342-20.743-159.91-21.332-193.22-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z",
    fillRule: "evenodd",
    transform: "matrix(.387 0 0 .38 -8.547 87.337)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#e10000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c31.488 61.414 48.722 166.77 50.387 170.52.14 4.44-4.718 6.382-7.077.832-2.48-3.315-12.667-100.18-49.138-172.18-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z",
    fillRule: "evenodd",
    transform: "matrix(.365 .112 -.145 .36 22.607 48.482)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#0000c4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.63 244.16l54.663 57.728.963-1.24-54.66-57.728-.965 1.24zm-38.08 9.434L323.086 329l1.254-1.186-71.535-75.407-1.254 1.187z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 60.236v88.583l17.717 88.582 17.717-88.583V60.235H478.35z",
    transform: "matrix(.052 -.05 .067 .068 293.042 348.857)",
    stroke: "#000",
    strokeWidth: 4.104,
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 60.236v88.583l17.717 88.582 17.717-88.583V60.235H478.35z",
    transform: "matrix(.052 -.05 .067 .068 311.488 319.402)",
    stroke: "#000",
    strokeWidth: 4.104,
    fill: "gray"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.18 272.84s-17.716 336.61 53.15 336.61 106.3-35.433 106.3-35.433l-.86-185.03-158.59-116.15z",
    transform: "matrix(-.34 0 0 .486 438.465 -20.46)",
    stroke: "#000",
    fill: "#ffdf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.46 304.2c0 17.717-7.846 269.82 27.587 269.82s88.583-17.717 88.583-17.717l-.86-167.31-115.31-84.79z",
    transform: "matrix(-.34 0 0 .486 438.465 -20.46)",
    stroke: "#000",
    fill: "#0000c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.52 321.16c0 17.717 4.525 217.42 39.958 217.42h53.15l-.86-149.59-92.248-67.833z",
    transform: "matrix(-.34 0 0 .486 438.465 -20.46)",
    stroke: "#000",
    fill: "#e10000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.452 112.217l-54.662 57.728-.963-1.24 54.662-57.728.962 1.24z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "#005b00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z",
    transform: "matrix(.124 -.056 .06 .266 243.637 183.89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z",
    transform: "matrix(.148 -.04 .052 .294 230.03 162.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z",
    transform: "matrix(.175 .107 -.022 .3 233.795 77.035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z",
    transform: "matrix(.186 .023 .012 .333 217.135 111.378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z",
    transform: "matrix(.136 .126 -.028 .268 259.09 75.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z",
    transform: "matrix(.17 0 .026 .304 221.8 131.72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z",
    transform: "matrix(.15 -.054 .05 .29 229.01 173.214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z",
    transform: "matrix(.15 -.025 .038 .298 230.934 150.527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z",
    transform: "matrix(.168 .115 -.038 .285 240.29 74.095)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z",
    transform: "matrix(.184 .04 -.004 .333 220.513 98.363)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z",
    transform: "matrix(.128 .128 -.043 .25 265.86 77.48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z",
    transform: "matrix(.18 .01 .006 .31 218.663 121.27)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 272.84s-35.433 336.61 70.866 336.61c88.583 0 88.583-53.15 106.3-53.15l-17.72-124.02-159.45-159.44z",
    transform: "matrix(-.44 0 0 .465 485.82 16.967)",
    stroke: "#000",
    fill: "#ffdf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.61 308.27c0 17.717-35.433 212.6 53.15 265.75 35.433 17.716 88.582-17.717 88.582 0l-17.71-141.74-124.02-124.01z",
    transform: "matrix(-.44 0 0 .465 485.82 16.967)",
    stroke: "#000",
    fill: "#0000c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.05 343.7c0 17.717-17.716 159.45 35.433 194.88 35.433 35.433 124.02 25.822 124.02 25.822l-70.87-132.12-88.58-88.58z",
    transform: "matrix(-.44 0 0 .465 485.82 16.967)",
    stroke: "#000",
    fill: "#e10000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.328 143.963l-71.534 75.407-1.254-1.187 71.533-75.407 1.255 1.186z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.63 184.25l17.716 35.433V237.4c-.865-1.305 0 17.716-17.716 17.716-17.717 0-17.717-35.433-17.717-35.433s-17.716 35.433-17.716 70.866 17.716 53.15 17.716 53.15-2.61-36.704 17.717-35.434c20.328 1.27 17.716 17.716 17.716 17.716v35.433h17.717v-141.73l17.717-35.433-27.136-53.15-26.014 53.15z",
    transform: "matrix(-.102 -.107 -.08 .082 427.91 169.68)",
    stroke: "#000",
    fill: "#cececc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.82 95.67l-26.323 70.865 17.717 53.15-35.433-17.716 35.434 53.148v35.433h17.716v-35.43l35.433-53.15-35.433 17.717 17.717-53.15L557.82 95.67z",
    transform: "matrix(-.08 -.12 -.105 .07 407.057 163.395)",
    stroke: "#000",
    fill: "#cececc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c0 35.8 20.917 187.81 22.582 191.56.14 4.44-4.718 6.382-7.077.832-6.55-17.342-20.743-159.91-21.332-193.22-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z",
    transform: "matrix(-.303 0 0 .234 460.08 77.33)",
    stroke: "#000",
    fill: "#e10000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c31.488 61.414 48.722 166.77 50.387 170.52.14 4.44-4.718 6.382-7.077.832-2.48-3.315-12.667-100.18-49.138-172.18-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z",
    transform: "matrix(-.285 .07 .114 .22 435.684 53.448)",
    stroke: "#000",
    fill: "#0000c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c0 35.8 20.917 187.81 22.582 191.56.14 4.44-4.718 6.382-7.077.832-6.55-17.342-20.743-159.91-21.332-193.22-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z",
    transform: "matrix(-.387 0 0 .38 511.648 87.337)",
    stroke: "#000",
    fill: "#e10000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c31.488 61.414 48.722 166.77 50.387 170.52.14 4.44-4.718 6.382-7.077.832-2.48-3.315-12.667-100.18-49.138-172.18-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z",
    transform: "matrix(-.365 .112 .145 .36 480.487 48.482)",
    stroke: "#000",
    fill: "#0000c4"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.35 698.03c17.717 10.652 37.09 8.268 53.15 0V556.3h-35.433c17.717 53.15 17.717 106.3-17.717 141.73z",
    fill: "#e10000",
    transform: "matrix(.44 0 0 .465 17.296 16.967)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.78 609.45c0 88.582-42.466 108.27-42.466 125.98 17.716 0 29.465-8.248 42.466-19.685 17.716-17.717 19.426-107.68 17.716-106.3H513.78z",
    transform: "matrix(.265 0 0 .524 103.226 -43.228)",
    fill: "#0000c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 609.45c-.81 51.77-44.794 99.64-36.497 110.24 9.474 9.475 36.497-21.654 71.93-3.937 17.717-17.717 19.427-107.68 17.717-106.3h-53.15z",
    transform: "matrix(.265 0 0 .524 103.226 -43.228)",
    fill: "#0000c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.78 609.45c0 88.582-40.696 94.47-40.696 118.09 17.717 0 40.603-12.912 40.696-11.79 17.716-17.718 19.426-107.68 17.716-106.3H513.78z",
    transform: "matrix(.265 0 0 .35 94.948 63.145)",
    fill: "#ffdf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 609.45c-.81 51.77-43.73 95.702-35.433 106.3 9.474 9.475 35.433-17.717 70.867 0 17.716-17.717 19.426-107.68 17.716-106.3h-53.15z",
    transform: "matrix(.265 0 0 .35 94.948 63.145)",
    fill: "#ffdf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 698.03c17.717 10.652 37.09 8.252 53.15-.015v-141.72h-35.433c17.717 53.15 17.717 106.3-17.717 141.73z",
    transform: "matrix(-.44 0 0 .465 485.82 16.974)",
    fill: "#e10000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.78 609.45c0 88.582-42.466 108.27-42.466 125.98 17.716 0 29.465-8.248 42.466-19.685 17.716-17.717 19.426-107.68 17.716-106.3H513.78z",
    transform: "matrix(-.265 0 0 .524 399.886 -43.223)",
    fill: "#0000c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 609.45c-.81 51.77-44.794 99.64-36.497 110.24 9.474 9.475 36.497-21.654 71.93-3.937 17.717-17.717 19.427-107.68 17.717-106.3h-53.15z",
    transform: "matrix(-.265 0 0 .524 399.886 -43.223)",
    fill: "#0000c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.78 609.45c0 88.582-40.696 94.47-40.696 118.09 17.717 0 40.603-12.912 40.696-11.79 17.716-17.718 19.426-107.68 17.716-106.3H513.78z",
    transform: "matrix(-.265 0 0 .35 408.168 63.152)",
    fill: "#ffdf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 609.45c-.81 51.77-43.73 95.702-35.433 106.3 9.474 9.475 35.433-17.717 70.867 0 17.716-17.717 19.426-107.68 17.716-106.3h-53.15z",
    transform: "matrix(-.265 0 0 .35 408.168 63.145)",
    fill: "#ffdf00"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.56 77.952l-89.676 35.434 89.676 35.434 44.837-17.717 22.42 17.717 22.418 35.433 22.42-35.433 22.418-17.717 1201.9-.002V95.668l-1201.9.002-22.42-17.718c0-17.716 4.704-35.433 22.42-35.433 17.717 0 54.242-.003 89.675-.003 0-17.716-44.838-53.15-134.51-53.15-89.675 0-134.51 35.434-134.51 53.15l89.675.002c17.716 0 22.42 17.716 22.42 35.432l-22.44 17.717-44.84-17.717z",
    transform: "matrix(.09 0 0 .17 174.417 269.463)",
    strokeWidth: 4.467,
    fill: "#908f8a"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.21 0 0 .207 173.1 277.19)",
    strokeWidth: 1.838,
    fill: "#b74d00",
    d: "M204.35 95.67h336.61v17.718H204.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.21 0 0 .207 173.1 277.19)",
    strokeWidth: 1.838,
    fill: "#b74d00",
    d: "M204.35 77.955h336.61v17.717H204.35zm0-17.718h336.61v17.717H204.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.21 0 0 .207 173.1 277.19)",
    strokeWidth: 1.838,
    fill: "#b74d00",
    d: "M204.35 42.522h336.61V60.24H204.35zm0-17.717h336.61v17.717H204.35z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.21 0 0 .207 173.1 277.19)",
    strokeWidth: 1.838,
    fill: "#b74d00",
    d: "M204.35 7.09h336.61v17.716H204.35zm0-17.718h336.61V7.09H204.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.23 60.236l137.8 124.02h19.686l-137.8-124.02H423.23z",
    transform: "matrix(.19 0 0 .207 139.765 262.532)",
    strokeWidth: 3.255,
    fill: "#908f8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.23 60.236l137.8 124.02h19.686l-137.8-124.02H423.23z",
    transform: "matrix(.19 0 0 -.207 139.765 313.11)",
    strokeWidth: 3.255,
    fill: "#908f8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 60.236v124.02h17.716V60.236H425.2z",
    transform: "matrix(.21 0 0 .207 130.46 262.532)",
    strokeWidth: 3.087,
    fill: "#908f8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.23 60.236l137.8 124.02h19.686l-137.8-124.02H423.23z",
    transform: "matrix(.19 0 0 .207 173.23 262.532)",
    strokeWidth: 3.255,
    fill: "#908f8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.23 60.236l137.8 124.02h19.686l-137.8-124.02H423.23z",
    transform: "matrix(.19 0 0 -.207 173.23 313.11)",
    strokeWidth: 3.255,
    fill: "#908f8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 60.236v124.02h17.716V60.236H425.2z",
    transform: "matrix(.21 0 0 .207 189.958 262.532)",
    strokeWidth: 3.087,
    fill: "#908f8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 60.236v124.02h17.716V60.236H425.2z",
    transform: "matrix(.21 0 0 .207 163.927 262.532)",
    strokeWidth: 3.087,
    fill: "#908f8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 60.236v124.02h17.716V60.236H425.2z",
    transform: "matrix(.21 0 0 .207 156.49 262.532)",
    strokeWidth: 3.087,
    fill: "#908f8a"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ffdf00",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M655.51 396.85c0 88.016-55.56 159.45-124.02 159.45-68.456 0-124.02-71.433-124.02-159.45 0-88.015 55.56-159.45 124.02-159.45 68.457 0 124.02 71.433 124.02 159.45zm-17.717 0c0 78.237-47.622 141.73-106.3 141.73-58.677 0-106.3-63.495-106.3-141.73 0-78.236 47.622-141.73 106.3-141.73 58.677 0 106.3 63.497 106.3 141.73z",
    transform: "matrix(.44 0 0 .465 17.296 16.967)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.75 249.94c-14.836-8.072-31.144-12.537-48.258-12.537s-33.422 4.465-48.257 12.537l6.893 16.323c12.716-7.175 26.695-11.144 41.364-11.144s28.648 3.968 41.364 11.143l6.894-16.323z",
    transform: "matrix(.44 0 0 .465 17.296 16.967)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.75 249.94c-14.836-8.072-31.144-12.537-48.258-12.537s-33.422 4.465-48.257 12.537l6.893 16.323c12.716-7.175 26.695-11.144 41.364-11.144s28.648 3.968 41.364 11.143l6.894-16.323z",
    transform: "matrix(.44 0 0 -.465 17.386 386.413)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M297.928 201.502c0 36.4-20.94 65.905-46.772 65.905-25.83 0-46.772-29.507-46.772-65.905 0-36.4 20.94-65.904 46.772-65.904 25.83 0 46.772 29.507 46.772 65.904z",
    fillRule: "evenodd",
    fill: "#a7cfff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M637.8 396.85c1.133 26.658-4.634 39.635-11.89 67.356-1.912 2.98-10.966-6.537-16.447-11.236s-7.812 4.24-14.537-3.046c-6.725-7.284-11.05 2.058-15.983-4.095s-51.3-7.057-51.366-7.586c4.59-2.276 28.27.152 24.474-11.193-4.3-11.72-31.093-.35-34.69-15.364-2.44-14.907-53.567-15.543-57.22-19.225 1.444 5.665 39.728 8.05 38.814 22.57-.833 5.916-37.693 7.645-41.247 12.652-3.045 6.295 28.927-1.707 30.114 6.032-.077 3.185-4.704.068-21.357 4.99-8.326 2.46 15.454 10.33 6.41 14.637-9.045 4.308-28.26 6.188-27.433 7.998 2.94 8.908 44.693 19.536 40.535 21.065-14.754 6.56-22.552 10.872-29.627 14.652-19.24-25.653-31.146-61.087-31.146-100.2 31.716-11.405 24.968-13.735 83.645-13.735s77.98 2.33 128.95 13.735z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#afff7b",
    transform: "matrix(.44 0 0 .465 17.296 16.967)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M637.8 396.85c-8.07 0-16.454 3.4-25.07 3.4-8.617 0-17.465-3.4-26.466-3.4s-19.287 4.532-28.512 4.532c-9.224 0-17.388-4.53-26.676-4.53-9.287 0-18.566 3.397-27.755 3.397s-18.288-3.4-27.218-3.4-17.69 3.4-26.2 3.4-16.77-3.4-24.7-3.4c0-19.56 2.976-38.197 8.358-55.15 27.075 2 11.042-15.716 27.075-15.716 8.655 0 17.434 1.86 25.238 9.788 2.447 0 14.48-11.373 27.912-9.788 13.432 1.586 8.492 27.272 26.37 28.637 9.063 6.797 14.393 11.134 26.78 13.872 17.716 1.606 68.35-2.5 68.704-.194a188.21 188.21 0 0 1 2.16 28.552z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff",
    transform: "matrix(.44 0 0 .465 17.296 16.967)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M549.85 473.94c0-5.664 13.512-9.462 13.512-18.524s-11.914-9.35-12.38-17.86c-.2-3.46 10.32-7.046 14.915-7.335s8.493 7.42 8.493 9.12-4.662-4.192-8.578-4.378-12.313.63-12.313 2.33c0 3.4 14.85 7.598 13.717 18.925-1.132 11.327-12.71 14.657-12.71 18.055s5.056 12.86 5.056 12.86-9.713-7.53-9.713-13.192z",
    fillRule: "evenodd",
    transform: "matrix(.155 0 0 .363 173.98 69.56)",
    stroke: "#000",
    strokeWidth: "1pt"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M549.85 473.94c0-5.664 13.512-9.462 13.512-18.524s-11.95-9.348-12.38-17.86c-.946-3.962 11.814-6.544 16.41-6.833s9.985 7.92 9.985 9.62-5.41-5.195-9.325-5.38-14.553.63-14.553 2.33c0 3.398 14.85 7.597 13.717 18.924-1.132 11.327-12.71 14.657-12.71 18.055s5.056 12.86 5.056 12.86-9.713-7.53-9.713-13.192z",
    fillRule: "evenodd",
    transform: "matrix(-.155 0 0 .363 346.52 69.267)",
    stroke: "#000",
    strokeWidth: "1pt"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M261.336 224.545c0 1.006-.492 1.82-1.098 1.82-.606 0-1.098-.814-1.098-1.82s.492-1.822 1.098-1.822c.606 0 1.098.816 1.098 1.822zm14.108 5.415h.352v14.712h-.352zm3.172-1.116h.353v14.712h-.354z",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M276.153 236.91l.003-.37 3.002.515-.003.372z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M497.26 478.07s26.052 11.328 31.716 18.124c5.664 6.797 3.398 6.796 3.398 6.796l57.77 2.266c0-3.398 10.193-3.4 12.46-11.328 2.264-7.93 2.264-10.194 2.264-10.194l-18.123 5.664 1.132-10.194H572.02l-2.266 10.194-33.982-1.133 2.266-27.186-6.796 1.132-1.133 26.053c-1.134 0-31.718-7.93-32.85-10.195z",
    fillRule: "evenodd",
    transform: "matrix(.44 0 0 .465 15.3 17.494)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#b74d00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M440.53 316.28s37.645-11.214 92.11-10.413 92.11 12.815 91.31 12.815-10.414-18.422-10.414-18.422-38.446-10.412-81.697-11.213c-43.253-.8-80.898 8.01-80.097 8.81L440.53 316.28z",
    fillRule: "evenodd",
    stroke: "#fede00",
    strokeWidth: "1pt",
    fill: "#fede00",
    transform: "matrix(.44 0 0 .465 17.296 16.967)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#38a9f9",
    d: "M241.038 152.85l10.236-.2.103 5.965-10.236.198zm-23.622 3.245l-3.61 5.875 12.2-1.503-.978-5.874-7.612 1.502zm10.399-2.26l10.203-.897.468 5.944-10.202.897zm36.86-.609l-10.217-.686-.36 5.953 10.218.686zm22.025 3.738l3.713 7.313-11.05-2.727 1.23-5.822 6.108 1.236zm-8.857-2.126l-10.154-1.382-.723 5.916 10.154 1.382z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M532.64 323.49l-2.58-13.47-7.54 11.46 2.77-13.43-11.34 7.7 7.7-11.35-13.43 2.78 11.45-7.54-13.47-2.58 13.47-2.58-11.45-7.53 13.43 2.77-7.7-11.35 11.34 7.7-2.77-13.43 7.54 11.46 2.58-13.47 2.57 13.47 7.54-11.46-2.77 13.43 11.35-7.7-7.71 11.35 13.44-2.77-11.46 7.53 13.47 2.58-13.47 2.58 11.46 7.54-13.44-2.78 7.71 11.35-11.35-7.7 2.77 13.43-7.54-11.46z",
    transform: "matrix(.44 0 0 .465 17.296 16.967)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M547.05 293.86c0 9.29-6.634 16.82-14.818 16.82s-14.818-7.53-14.818-16.82 6.634-16.82 14.818-16.82 14.818 7.53 14.818 16.82z",
    fillRule: "evenodd",
    transform: "matrix(.43 0 0 .388 23.813 41.07)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#ffdf00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M252.06 153.375c0 .412-.948.746-2.118.746s-2.118-.333-2.118-.745.948-.746 2.118-.746 2.118.333 2.118.745zm4.588-.001c0 .412-.71.746-1.588.746s-1.59-.334-1.59-.746c0-.41.712-.745 1.59-.745s1.588.333 1.588.744z",
    fillRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M529.43 297.86l.8.8c-1.9-1.9-.995-1.125 1.603 3.204 2.393-.495 3.09-1.39 4.806-2.403",
    transform: "matrix(.423 -.132 .125 .446 -10.137 93.053)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M527.83 304.27l.8.8c-1.9-1.9-1.123-.994 3.205 1.603 4.027.544 8.092-1.196 10.412-4.005",
    transform: "matrix(.44 0 0 .465 16.59 16.967)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M223.462 170.743s.705 5.958-3.876 13.407c-4.582 7.45-3.877 4.842-3.877 4.842s2.114 4.097 1.76 4.097-3.523-3.725-3.523-3.725l-3.876 4.096s3.525-6.33 3.173-6.33-1.058-2.235-1.058-2.235l2.82-1.117s4.23-7.82 4.23-7.45-12.69 8.567-12.69 8.567l16.917-14.152zm2.821 2.237c-.353 0 1.762 5.96 3.524 8.938 1.762 2.98 1.762 6.704 1.762 6.704l5.99 2.98-7.753-11.546 4.934 1.862-8.457-8.94zm0 15.642s4.23 4.47 4.58 5.96.354 4.84.354 4.84l-1.762-3.724-2.467 3.352s1.762-5.214 1.41-5.587-2.82 1.863-2.82 1.863 1.057-2.98 1.057-3.353 0-2.234-.352-3.35zm-21.147 10.425c1.41-1.117 4.23-1.862 4.23-1.862s-1.763 2.98-2.115 2.98-1.41 0-2.114-1.118zm48.634-16.387s9.162 5.587 9.162 5.96-5.99-2.607-5.99-2.607l-3.172-3.353zm-16.562-11.545c.705.372 13.392 10.8 13.04 10.8s-5.64-2.98-5.64-2.607v2.607l-2.82-5.96-.704 2.236-3.876-7.075zm3.168 16.758l3.524 7.076 3.524-.745s-6.696-6.332-7.048-6.332zm10.93-4.469c0 1.118.352 6.704.352 6.704s2.115 1.863 2.115 1.49-2.115-7.82-2.467-8.194z",
    fillRule: "evenodd",
    fill: "#b7e1ff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M147.855 92.216s15.836-8.76 33.865-15.286c18.03-6.525 38.253-10.812 40.925-10.812 5.343 0 14.5 13.422 16.027 13.422 1.526 0 7.63-3.728 15.263-3.728s12.21 5.965 13.737 5.965h13.737c1.525 0-4.58-14.914 0-14.168 2.288.372 21.75 3.355 39.875 9.227 18.124 5.872 43.854 16.24 43.854 16.24s-42.052 5.615-53.203 3.954c-1.526.746-.075 9.864-2.214 5.853-3.513-.802-16.41-2.813-18.7-2.813s-6.56 2.586-12.665 4.078c-6.105 1.49-13.737 3.728-13.737 3.728l9.922 15.66-12.21 5.965s-7.632-17.896-10.684-17.896-4.58 12.677-8.395 11.93c-3.816-.744-5.342-11.93-8.395-14.912-3.053-2.983-19.147-4.07-25.253-5.56-6.105-1.49-15.96-2.643-21.3-4.134-5.343-1.492-10.685 3.728-12.974 3.728-2.29 0 3.053-4.474.764-5.22s-3.816 2.238-5.342 2.238c-1.527 0-17.553-2.983-19.08-3.73-1.526-.745 3.817-3.727 2.29-3.727h-6.105z",
    fillRule: "evenodd",
    fill: "#984000"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M462.91-64.94c0 21.15-20.5 38.298-45.79 38.298S371.327-43.79 371.327-64.94s20.5-38.298 45.79-38.298S462.91-86.09 462.91-64.94z",
    fillRule: "evenodd",
    transform: "matrix(.165 0 0 .2 184.85 97.497)",
    stroke: "#772600",
    strokeWidth: 3.706,
    fill: "gray"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M284.74-59.945c6.66-6.66 14.987-16.65 36.633-16.65 4.996-1.666 4.996-11.657 16.65-11.657 11.657 0 8.327 9.99 16.653 13.32 8.325 3.33 76.596-3.33 76.596-3.33s6.66 4.996 6.66 11.657c0 6.66-4.995 11.656-6.66 11.656s-68.27-4.995-73.266-3.33c-4.995 1.666-8.326 3.33-19.982 3.33-11.655 0-14.986-11.655-23.31-11.655-8.327 0-16.653-1.665-29.974 6.66z",
    fillRule: "evenodd",
    transform: "matrix(.206 0 0 .24 165.048 100.617)",
    stroke: "#772600",
    strokeWidth: 5.25,
    fill: "#984000"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M487.88-76.597h26.642c9.572.114 12.873 3.005 21.647 3.33h23.31c8.476-.314 12.952-2.295 21.648-3.33 14.504-.175 9.555-1.306 6.66-9.99-2.625-6.565-2.95-9.61-6.66-13.322-1.396-7.944-4.655-10.77-4.996-19.98-1.527-7.027-4.342-11.753-1.665-19.983 3.84 5.647 5.387 7.97 14.986 8.326 10.045 0 13.937-.206 19.982 3.33 4.663 4.89 10.886 3.33 19.982 3.33 7.677 1.406 8.96 5.313 14.986 8.326 7.103 3.935 11.694 4.995 21.646 4.995 7.967 1.422 14.88 2.578 19.98 4.995 4.25 5.08 10.952 6.338 19.983 6.66 5.05 0 8.95-.524 13.32-1.665 7.678.37 15.474 0 24.978 0 6.163 7.21 7.587 9.862 18.317 9.99 7.338 5.155 13.527 6.037 19.982 8.327h24.976c8.928.687 11.79 4.35 19.98 6.66 8.115 3.768 15.722 6.35 21.648 8.326 5.89 1.28 13.574 1.665 21.646 1.665 6.183 3.175 13.61 3.46 18.317 6.66 6.89 1.477 16.302 3.215 21.647 4.996 8.816 1.168 12.187 3.94 19.98 4.995 6.704 1.915-2.223 3.56-6.66 4.995-9.826-.364-10.536-3.946-19.98-4.995-5.024-2.94-12.64-2.548-19.982-4.996h-1.666c6.6 3.903 12.948 6.422 9.99 13.32-8.49 0-15.366-1.097-23.31-1.665-8.385-1.616-12.227-3.33-21.647-3.33 9.394-2.264 11.854.27 18.315 3.33 2.396 8.06-2.725 4.996-11.656 4.996-7.61-2.73-12.174-5.983-21.648-6.66h-19.98c9.89.366 11.976 4.1 18.315 8.326.518 2.59-.132 2.472-4.995 3.33-5.16-4.478-11.89-6.013-19.982-8.326-7.88-.28-16.217-.965-23.31-3.33-4.868-.304-4.117-6.177 6.66 3.33 6.532 3.843 8.832 6.946 8.325 9.99-8.576-2.143-12.825-5.58-18.317-8.324-7.736-2.855-14.128-3.33-23.312-3.33-8.61-2.266.894-3.574 6.66 4.995 12.38 8.77-1.632 5.007-6.66 3.33-7.507-2.144-15.284-5.184-21.646-6.66-5.046-1.44-9.44-2.855-14.986-3.33 8.63.785 11.57 3.823 14.986 9.99 8.755 6.032-.384 3.1-8.326 1.666-5.07-4.402-11.487-6.658-14.986-11.656-8.35-4.176-8.563-8.982-3.33 1.665 1.363 3.407 1.11 10.795 1.665 11.656-6.136-6.625-4.825-8.325-11.656-8.325-4.634-3.244-11.496-5.765-14.986-9.99-6.435-.604-6.84-2.9-13.32-4.996 5.34 6.273 12.39 12.478 16.65 18.315 7.598 4.242 9.7 8.06 14.987 11.656 2.14 3.64 7.904 6.657 1.665 1.666-7.144-7.043-12.46-8.67-23.312-13.32-6.15-4.96-8.37-7.045-14.986-11.657-9.003-2.905-5.508-4.543 0 4.995 6.318 5.77 11.17 12.23 16.652 16.65 3.767 4.908 10.136 10.12 14.986 13.322 1.5 2.25 5.99 2.664 0 3.33-5.09-4.598-12.398-7.53-18.317-11.656-8.302-2.34-12.19-6.652-18.316-11.655-3.9-5.85-10.383-10.38-14.987-14.986-9.63-3.77 1.9 3.636 4.995 8.325 2.153 6.068 4.788 11.035 6.66 16.65 2.78 5.56-8.47-1.327-11.655-3.33-7.32-4.157-12.674-6.937-21.647-8.325-5.98-1.3-13.602-2.468-19.982-3.33-7.614-2.05 4.042 4.8 8.326 11.656 8.418 7.908-8.332 1.425-13.32 0-8.224-1.645-16.288-1.666-24.978-1.666-10.67.628-3.05 1.947 0 6.66 3.287 2.53 5.637 7.855 4.995 9.992-7.032-.95-13.025-3.023-21.646-3.33-6.96 2.32-15.344 1.665-23.31 1.665-.382 4.19 1.443.654 4.994 4.995 5.763 2.34 9.585 5.177 8.326 8.326H497.87c-5.29 1.447 1.14.704 5 6.663-2.16 5.403-4.95 3.332-11.655 3.332-4.545-1.818-13.598-2.636-18.317-4.996-4.69 0-4.336-1.22-8.325-1.665 14.035 9.93 7.073 7.45 14.986 14.987 1.366.456 4.523 1.665 1.664 1.665M371.32 73.265c-.997 0-3.2-5.375-6.66-9.99-2.327-6.05-5.392-2.59-8.326-11.657.348-9.402.684-11.094 0-19.982-6.863-4.783-9.714-6.27-14.986-14.986-8.46-7.078 1.236-19.063 2.845-27.85-7.375-1.638-11 11.477-22.34 16.194-8.156 5.492-.912-11.354-4.892-21.188-2.774-13.872-10.825 6.956-13.91 12.862-5.467 3.718-7.128 8.542-14.986 1.665 0-5.144 4.937-19.49 2.845-22.28-7.815 3.815-18.088 15.49-26.158 17.284-8.13-1.767 1.77-14.828 1.77-24.518-2.938-.98-14.696 25.755-19.52 26.002-4.824.248-2.713-25.993-4.972-25.428-3.542 4.96-10.65 15.43-15.576 18.948-9.454-1.22 1.398-17.435 2.845-23.427 1.628-7.168-8.905 13.75-14.502 15.102-4.1 3.554-12.237 6.072-14.986 6.66 3.24-6.13 19.076-18.712 17.935-22.278-9.21.34-23.31 12.556-31.256 13.952-5.19 0-12.387 1.758-13.32 1.665.448-7.926 19.418-14.65 22.445-19.465-9.306 1.494-27.186 9.706-32.436 16.135-6.146 1.336-13.944 3.02-19.983 0 .897-7.475 14.856-21.998 17.936-26.758-8.396 3.697-12.642 6.59-21.647 8.325-1.652 1.652-6.524 5.23-4.995 1.665 2.656-6.945 6.676-10.11 9.99-14.986-7.45 1.364-10.28 5.634-18.315 9.99-5.094.222-19.646 14.855-24.596 15.103-11.45 8.382-16.01 9.807-28.308 13.32-7.587 1.356-11.26 2.934-14.986 6.66 3.796-6.687 9.597-13.092 14.986-16.65 3.677-5.567 7.12-10.195 14.986-13.32 1.897-2.32 7.188-2.906 1.665-3.33-4.746 4.236-12.696 8.965-16.65 11.655-5.102 3.207-11.01 6.48-13.322 4.995 2.62-7.197 7.438-8.902 11.657-14.986 8.81-5.604.042-1.914-6.66 0-4.338 3.868-12.122 6.727-18.316 9.992-7.113 1.856-11.703 6.132-19.98 8.326 0 2.375 2.364-4.25 3.33-6.66 6.83-7.41 8.656-9.476 16.65-11.657 1.912-2.866 4.42-1.664-1.665-1.664-4.514 4.024-10.81 6.212-16.65 9.99-5.892 1.282-13.575 1.666-21.648 1.666-10.355 1.243-9.46 2.025 0-3.33 5.357-5.042 9.77-3.775 9.99-9.99C10.394-40.43 2.78-37.1-4.998-33.304c-6.434.19-8.133 1.665-14.985 1.665 3.298-3.415 5.277-7.633 9.99-9.99 6.896-7.663-4.377-1.478-6.66 0H-41.63c-4.465 5.58-.23.05 3.33-3.33 4.306-2.24 8.756-5.155 8.326-6.66-4.972 4.314-10.726 6.297-14.986 9.99-4.64 1.39-9.99 2.084-9.99 3.33 3.626-5.346 9.524-8.576 13.32-13.32 5.612-1.22 10.396-2.936 11.656-4.996h-23.312 16.65c8.4 0 15.63-.75 23.313-1.665 13.263-2.21-1.16-3.33-8.326-3.33-1.39-2.548 4.11-3.987 9.99-4.995 5.024-2.38 11.233-4.493 16.65-6.66 5.257-1.434 12.707-5.81 13.322-6.66-5.015.263-4.975 1.4-9.99 1.664 7.446-.574 12.8-1.666 21.646-1.666 8.028-2.58 14.906-5.41 21.647-8.326 2.936-3.588 4.24-3.33-3.33-3.33 6.713-2.158 16.238-3.193 21.647-4.995 7.872-1.687 14.9-4.253 19.982-6.66 4.876-3.316 7.69-7.176 13.32-9.99 6.528 4.437 6.602 4.994 18.318 4.994 9.41-.112 15.17-2.373 19.98-6.66 7.208-1.966 8.483-5.43 16.652-6.66 7.444 1.328 15.03 1.664 23.312 1.664 8.096-2.12 15.677-6.01 21.647-9.99 5.093-2.502 11.14-6.12 16.65-8.326 6.07 3.133 10.844 5.65 18.318 6.66 7.728-1.148 11.747-4.868 18.317-6.66 3.577-4.33 8.777-6.632 14.986-8.325 9.67-4.75 8.913 1.573 13.32 6.66 4.896 5.132 11.374 2.68 18.318 4.995 3.83 5.893 6.647 9.914 11.657 13.32 3.89 4.71 8.508 6.035 16.65 6.66 2.968 3.958.602 6.812 6.662 8.327 2.387 2.53 6.517 3.606 9.99 4.995",
    transform: "matrix(.206 0 0 .24 165.048 103.825)",
    stroke: "#772600",
    strokeWidth: 3.5,
    fill: "none"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M468.74 30.803v.833c0-2.327-.103-1.09 1.665 3.33.595 3.64-.81 3.22-2.498 5.828-.286 3.723-.832 6.4-.832 10.823-.537 3.612-2.57 7.04-4.163 9.99-1.604 3.133-8.555 4.87-8.326 9.16-3.99 1.14-4.084-1.445-4.162-5.83-2.386-2.726-3.212-6.466-4.996-9.99-1.108-3.476-3.47-6.032-4.995-9.99-2.46-3.787-4.546-4.876-6.66-9.16-.827-2.065-.683-4.617-2.498-5.827-2.72-3.438-4.49-3.99-9.16-4.163-3.59.845-4.97 2.416-8.324 3.33-2.57.857-7.57.58-10.823 1.666-.808 1.314 1.6 1.94 2.498 4.995-2.135 1.764-2.926 4.883-4.163 7.493-1.965 2.487-3.283 3.706-4.163 7.494 1.362 2.316.2 5.387-1.666 7.493-.574 3.864-2.434 5.874-3.33 9.16-2.686 1.825-3.652 3.537-5.828 6.66-1.914 2.678-3.636 2.497-8.326 2.497-3.667-1-4.18-2.988-7.493-4.163-.352-1.056-.608-1.312-1.665-1.664",
    transform: "matrix(.206 0 0 .24 165.048 103.825)",
    stroke: "#782600",
    strokeWidth: 3.125,
    fill: "none"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M242.23 119.397s-.345 3.74-2.75 6.233-7.393 5.402-7.393 5.402 6.704-3.186 7.392-2.493c.686.69-4.3 6.232-4.3 6.232s6.534-5.818 7.393-5.818 2.75 5.68 3.438 5.54c.69-.138-1.546-7.202-1.202-8.31.343-1.108 0-7.064 0-7.064l-2.58.277zm15.468-.507s-.344 3.998-2.75 6.663-7.392 5.774-7.392 5.774 6.704-3.405 7.392-2.665c.687.74-4.298 6.663-4.298 6.663s6.532-6.22 7.392-6.22 2.75 6.072 3.438 5.924c.687-.15-1.547-7.7-1.203-8.885.343-1.184 0-7.55 0-7.55l-2.58.295zm-21.656-36.262c0 .745-.73 1.35-1.63 1.35s-1.63-.605-1.63-1.35.73-1.35 1.63-1.35 1.63.605 1.63 1.35z",
    fillRule: "evenodd",
    fill: "#812e00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc);
export default __webpack_public_path__ + "static/media/ec.c35ac1e031a1b0d15a1c47eac3e003ef.svg";
export { ForwardRef as ReactComponent };